__turbopack_context__.v({
  "Badges": "MFr7bG_Badges",
});
